import {TimeSlotItem} from './TimeSlotList';

export const generateTimeslotData = (timeslot: TimeSlotItem) => {
  const hasDiscount = (timeslot.discountPercentage ?? 0) > 0;
  return {
    startTime: timeslot.startTime,
    hasDiscount: (timeslot.discountPercentage ?? 0) > 0,
    totalPrice: timeslot.salePriceAmount,
    originalPrice: hasDiscount ? timeslot.fullPriceAmount : undefined,
  };
};
